import React, { useState } from 'react';
import { auth } from '../../config/firebase';
import { sendPasswordResetEmail } from 'firebase/auth';
import { message } from 'antd';
import { useMyContext } from '../../context/MyContext';
import Logo from "../../assets/logo.png";
import video from "../../assets/5262343_Above_Aerial_Area_1920x1080.mp4";
import { Link } from 'react-router-dom';

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const { forgotPassword } = useMyContext();

  const handleResetPassword = async (e) => {
    e.preventDefault();
    if (!email) {
      message.error('Please enter your email address');
      return;
    }

    setLoading(true);
    try {
      const result = await forgotPassword(email);
      if (result.isSuccess) {
        message.success('If an account exists for this email, a password reset link has been sent.');
        setEmail('');
      } else {
        throw new Error('Failed to send password reset email');
      }
    } catch (error) {
      console.error('Error sending password reset email:', error);
      message.error('Failed to send password reset email. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="w-full flex min-h-screen">
      <div className="lg:w-1/2 w-full lg:flex hidden justify-center items-center min-h-screen relative">
        <video autoPlay loop muted className="absolute inset-0 w-full h-full object-cover z-10">
          <source src={video} />
        </video>
      </div>
      <div className="lg:w-1/2 md:px-12 px-5 w-full bg-white flex flex-col justify-center items-center gap-4 min-h-screen">
        <img src={Logo} alt='' className='py-4 w-1/5' />

        <div className="space-y-2">
          <h2 className="md:text-3xl text-2xl text-center font-bold text-[#3C404B]">Forgot Password</h2>
          <h2 className="text-base font-normal text-center text-[#3C404B]">Enter your email address to reset your password.</h2>
        </div>

        <div className="w-full space-y-3">
          <form onSubmit={handleResetPassword}>
            <div className="flex flex-col gap-1 py-2">
              <label className="w-full text-base font-normal text-[#3C404B]" htmlFor="email">
                E-Mail Address
              </label>
              <input
                type="email"
                id="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="w-full py-3 px-6 text-base rounded-md border-[#00000026] border outline-none active:border-cus-blue focus:border-cus-blue"
                placeholder="Enter your email"
                required
              />
            </div>
            <button
              type="submit"
              className="w-full text-sm text-white rounded-md py-3 btnBg mt-4"
              disabled={loading}
            >
              {loading ? 'Sending...' : 'Reset Password'}
            </button>
          </form>
        </div>

        <div className="mt-4">
          <Link to="/" className="text-cus-red">
            Back to Login
          </Link>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;